<template>

  <div v-if="show" class="selectRegion">
    <div class="nav_top">
      <div class="flex_center">
        <a @click="close" href="javascript:void(0);" class="btn_back flex_center">
          <img class="icon-normal" src="@/assets/icon/icon_back.png"/>
        </a>
        <p class="title">지역선택</p>
      </div>
    </div>

    <div class="RegioninfoView">
      <div class="Regionlist">
        <template v-for="(item, index ) in list">
          <div @click="cityClick(item , index )" :class="index === checkCityIndex ? 'check_on':'' " class="flex_row_center" v-text="item.value"></div>
        </template>
      </div>
      <div class="Regiondetails">
        <template v-for="(item,index) in districtlist">
          <div @click="distClick( item  , index )" :class="index === checkdistIndex ? 'check_on':'' " class="flex_row_center" v-text="item.value"></div>
        </template>
      </div>
    </div>
  </div>

</template>

<script>

	export default {
		name: "selectRegion"
    ,data(){
		  return {
		    show:false
        ,success:null
        ,fail:null
        ,checkCityIndex:-1
        ,checkdistIndex:-1
        ,list:[]
        ,districtlist:[]
      }
    }
    ,methods:{
      cityClick(info , index ){
          this.checkCityIndex = index;
          // this.checkdistIndex = 0;
          this.districtlist = info.list;

      }
      ,distClick(info , index ){
        this.checkdistIndex = index;
        let cityinfo = this.list[this.checkCityIndex];
        if(cityinfo === undefined ){
          cityinfo = {};
        }
        let distinfo = this.districtlist[this.checkdistIndex];
        if(distinfo === undefined ){
          distinfo = {};
        }

        this.districtlist = [];
        this.list = [];
        this.checkdistIndex = -1;
        this.checkCityIndex = -1;

        this.success({
          citydata : cityinfo
          ,distdata : distinfo
        });
      }

      ,close(){
        this.districtlist = [];
        this.list = [];
        this.checkdistIndex = -1;
        this.checkCityIndex = -1;
        this.show = false;
      }
    }
	}
</script>

<style scoped>
  .selectRegion {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 10000;
  }

  .nav_top {
    border-bottom: 0.014rem solid #C8C8C8;
  }

  .RegioninfoView {
    padding: 1.667rem 0 0 0;
    display: flex;
    min-height: 100%;
  }

  .Regionlist {
    width: 3.479rem;
    border-right: 0.014rem solid #C8C8C8;

  }

  .Regionlist > div {
    padding: 0 0 0 0.694rem;
    height: 1.278rem;
  }


  .Regiondetails {
    width: 6.521rem;
  }

  .Regiondetails > div {
    padding: 0 0 0 0.694rem;
    height: 1.278rem;
  }

  .check_on {
    color: #F15929;
    background-color: #F8F7F4;
    border-right: 0.014rem solid #C8C8C8;
  }

  .Regiondetails .check_on {
    border:none;
  }

</style>



// WEBPACK FOOTER //
// src/components/selectRegion.vue